import styled from 'styled-components';

const WrapperStyled = styled.div`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  display: flex;
  padding: 20px;
  width: 100%;
  box-shadow: 0px 6px 12px rgba(56, 20, 81, 0.15);
  border-radius: 8px;
`;

const TextStyled = styled.div`
  margin: 25px 0px;
  font-family: cerapro;
  color: #2d1441;
  text-align: center;
  h3 {
    font-weight: 600;
    font-size: 18px;
    line-height: 21px;
    margin-bottom: 25px;
  }
  p {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
  }
`;

const ButtonsStyled = styled.div`
  width: 260px;
`;

export { WrapperStyled, TextStyled, ButtonsStyled };
